/* eslint-disable indent */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-expressions */

import { useState } from "react";
import dynamic from "next/dynamic";
import styled from "styled-components";
import Link from "next/link";
import ApnaLogo from "../ApnaLogo/ApnaLogo";
import Button from "../Buttons/Button";
import media, { mediaMaxWidth } from "../../utils/mediaQuery";
import Mixpanel from "../../utils/Mixpanel";
import useBranchIoLinkGeneration from "../../utils/BranchIO";
import { getUrlPath } from "../../utils/helpers";
import { BRANCH_APP_DOWNLOAD_CAMPAIGNS } from "../../utils/constants";

const Modal = dynamic(() => import("../Modal/Modal"));

const ModalContent = dynamic(() => import("../ModalContent/ModalContent"));

const Header = ({ source, userId, id, user, referrerId, name, customUtmMedium }) => {
	const [url] = useBranchIoLinkGeneration({
		id: referrerId || userId,
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.downloadAppCTA,
		section: user && user.full_name ? `Header_Get_App` : `Get_App`,
		pageType: source,
		customUtmMedium,
	});
	// const theme = useTheme();

	const [openModal, setOpenModal] = useState(false);

	const toggleModal = () => {
		setOpenModal(!openModal);
	};

	const getAppClick = () => {
		toggleModal();
		Mixpanel.track("Download App Button Click Mobile Header", {
			Source: source,
			User: user && user.full_name,
			page: getUrlPath(),
		});
	};

	return (
		<>
			<HeaderContainer id={id}>
				<HeaderWrapper>
					<HeaderLogoTextContainer>
						<HeaderLogoContainer>
							<Link href="/" passHref>
								<ApnaLogo />
							</Link>
						</HeaderLogoContainer>
						<HeaderTextContainer>
							<HeaderText>India ka sabse bada jobs group</HeaderText>
							{user?.full_name && (
								<HeaderSubText>
									{user && user.full_name} uses the apna app
								</HeaderSubText>
							)}
						</HeaderTextContainer>
					</HeaderLogoTextContainer>
					<DownloadButton onClick={getAppClick}>Get App</DownloadButton>
				</HeaderWrapper>
				{openModal && (
					<Modal
						isOpen={openModal}
						onRequestClose={toggleModal}
						shouldCloseOnOverlayClick={false}
					>
						<ModalContent
							pageType={source}
							url={url}
							toggleModal={toggleModal}
							name={name}
						/>
					</Modal>
				)}
			</HeaderContainer>
			<ApnaColorGrid>
				<ApnaColorGrid1 />
				<ApnaColorGrid2 />
				<ApnaColorGrid3 />
			</ApnaColorGrid>
		</>
	);
};

// Styles
const HeaderWrapper = styled.div`
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
	${media.extraSmall`
        max-width: 100%;
    `};
	${media.small`
        max-width: 100%;
    `};
`;

const DownloadButton = styled(Button)`
	height: 32px;
	line-height: 31px;
	font-size: 13px;
	padding: 0 5px;
`;
const HeaderLogoContainer = styled.div``;
const HeaderTextContainer = styled.div``;
const HeaderText = styled.h4`
	font-size: 16px;
	font-weight: 900;
	margin-bottom: 6px;
	margin-left: 15px;
	color: #fff;
`;
const HeaderSubText = styled.h6`
	font-size: 12px;
	font-weight: normal;
	margin-bottom: 6px;
	margin-left: 15px;
	color: #fff;
`;
const HeaderLogoTextContainer = styled.div`
	display: flex;
	align-items: center;
`;

const HeaderContainer = styled.header`
	padding: 15px;
	background-color: #4d3951;
	display: none;
	${mediaMaxWidth.small`
	&#share-post-header-mobile-view {
		display: block;
	}
	& ${HeaderLogoContainer} {
		& svg {
			width: 50px;
			height: 50px;
			border-radius: 9px;
		}  
	}
    `}
`;

const ApnaColorGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
`;
const ApnaColorGrid1 = styled.div`
	height: 4px;
	background-color: #2bb793;
`;
const ApnaColorGrid2 = styled.div`
	height: 4px;
	background-color: #83bde4;
`;
const ApnaColorGrid3 = styled.div`
	height: 4px;
	background-color: #ffd166;
`;

export default Header;
